import script from "./modal.vue?vue&type=script&setup=true&lang=js"
export * from "./modal.vue?vue&type=script&setup=true&lang=js"

import "./modal.vue?vue&type=style&index=0&id=119ea506&lang=css"

const __exports__ = script;

export default __exports__